import { swedishNumberFormatter } from './swedishNumberFormatter';
import { stringToNumberOrNull } from './stringToNumberOrNull';

export const priceStringFormatter = (value: string): string => {
  if (!value) {
    return '';
  }

  const valueAsNumber = stringToNumberOrNull(value.replace(/\D/g, ''));

  if (valueAsNumber === null) {
    return '';
  }

  return swedishNumberFormatter(valueAsNumber);
};
